<template>
    <div>
        <el-button type="primary" class="onlyBtn" plain icon="el-icon-download" @click="showManyCardImport">批量导入</el-button>
        <el-button type="primary" plain icon="el-icon-download" class="onlyBtn" @click="showOneCardImport">单卡导入</el-button>
        <el-button type="success" plain icon="el-icon-download" class="onlyBtn" @click="showOneCardImport1">号段导入</el-button>
        <el-button type="success" plain icon="el-icon-download" class="onlyBtn" @click="showOneCardImport12">复制导入</el-button>

        <!-- <el-button type="success" plain icon="el-icon-download" class="onlyBtn" @click="showImportApply">导入设备对应卡号</el-button>
        <el-button type="success" plain icon="el-icon-download" class="onlyBtn" @click="showImportApply1">设备批量切网</el-button>
        <el-button type="danger" icon="el-icon-delete" @click="deleteShebeiFlg = true">删除设备对应卡号</el-button>
        <el-button type="success" @click="confirmExportDialogVisible = true">导出设备对应卡号</el-button> -->
        <el-button type="success" plain class="onlyBtn" @click="updateBatchGroup">编辑用户可选系列</el-button>
        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column prop="createTime" label="导入时间" width="140" align="center"></el-table-column>
            <el-table-column prop="batchNo" label="导入批次" align="center"></el-table-column>
            <el-table-column prop="importTotal" label="导入张数（张）" align="center"></el-table-column>
            <el-table-column prop="importSuccess" label="导入成功张数（张）" align="center"></el-table-column>
            <el-table-column prop="importFail" label="导入失败张数（张）" align="center"></el-table-column>
            <el-table-column prop="agentName" label="卡片归属" align="center"></el-table-column>
            <el-table-column prop="pkgGroupName" label="套餐组名称" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" align="center"></el-table-column>
            <el-table-column prop="supplierTypeName" label="运营商" align="center"></el-table-column>
            <el-table-column prop="cardTypeName" label="卡类型" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.importFail > 0" type="text" size="small"
                        @click="getImportFailRecordListHandle(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <template v-if="batchImport">
                    <el-form-item label="导入Excel：" prop="uploadExcel">
                        <el-upload ref="upload" :action="uploadUrl('sim/import')" :headers="setHeader()" :limit="1"
                            :auto-upload="false" :data="importCardForm" :on-change="handleChange"
                            :on-success="handleSuccess">
                            <el-button slot="trigger" plain>导入Excel</el-button>
                            <el-button style="margin-left: 10px;" plain
                                @click="exportExcel('/mould/download?type=import')">导出模板</el-button>
                        </el-upload>
                    </el-form-item>
                </template>
                <template v-else-if="batchSimsImport">
                    <p>备注：号段导入仅仅支持iccid和接入号带有顺序的，中间不能断层，否则将一起导入</p>
                    <br>
                    <el-form-item label="开始ICCID号：" prop="iccid">
                        <el-input v-model.trim="importCardForm.iccidStart" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="结束ICCID号：" prop="iccid">
                        <el-input v-model.trim="importCardForm.iccidEnd" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="开始接入号：">
                        <el-input v-model.trim="importCardForm.intoNo" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="结束接入号：">
                        <el-input v-model.trim="importCardForm.intoNoEnd" clearable></el-input>
                    </el-form-item>
                </template>
                <template v-else-if="copyImport">
                    <p>备注：请保持复制的数量一样，否则将会导入错误</p>
                    <el-form-item label="ICCID：" class="iccid_textarea_range">
                        <el-input type="textarea" :rows="2" placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                            v-model="importCardForm.iccid">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="接入号：" class="iccid_textarea_range">
                        <el-input type="textarea" :rows="2" placeholder="请输入1个或多个接入号,多个请用逗号、空格、或者换行分隔"
                            v-model="importCardForm.intoNo">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="虚拟号（可选）：" class="iccid_textarea_range">
                        <el-input type="textarea" :rows="2" placeholder="请输入1个或多个虚拟号,多个请用逗号、空格、或者换行分隔"
                            v-model="importCardForm.virtualNo">
                        </el-input>
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item label="ICCID号：" prop="iccid">
                        <el-input v-model.trim="importCardForm.iccid" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="接入号：">
                        <el-input v-model.trim="importCardForm.intoNo" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="虚拟号：">
                        <el-input v-model.trim="importCardForm.virtualNo" clearable></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="importCardForm.agentId" filterable clearable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商：" prop="supplierCode">
                    <el-select v-model="importCardForm.supplierCode" filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="`${item.name + ' ( ' + item.alias + ' )'}`"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐组：" prop="basePkgGroup">
                    <el-select v-model="importCardForm.basePkgGroup" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="卡类型：" prop="cardType">
                    <el-select v-model="importCardForm.cardType">
                        <el-option v-for="item in simTypeOption" :value="item.code" :key="item.description"
                            :label="item.description"></el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="激活赠送："  prop="isReward">
                    <el-radio-group v-model="importCardForm.isReward">
                        <el-radio label="1">赠送</el-radio>
                        <el-radio label="0">不赠送</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="导入失败卡列表" :visible.sync="importFailVisible" width="1000px"
            :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="failReason" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>



        <el-dialog :append-to-body="true" title="导入设备对应卡号" :visible.sync="importVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/insert/shebei/info')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=shebei')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="切换设备" :visible.sync="importVisible1" width="600px"
            :close-on-click-modal="false">
            <p style="color:red;">注意：虚拟号/iccid  要是当前在用的卡板,并且设备正常在用 才可切换</p>
            <el-form :model="dealWithForm" ref="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/batchQie/shebei')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success='handleSuccessSn' :data="dealWithForm">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="在用卡槽：" prop="curSimCato">
                    <el-select v-model="dealWithForm.curSimCato" clearable>
                        <el-option value=0 label="移动卡"></el-option>
                        <el-option value=1 label="电信卡"></el-option>
                        <el-option value=2 label="联通卡"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调用接口：" prop="onQie">
                    <el-radio-group v-model="dealWithForm.onQie">
                        <el-radio :label=1>调用</el-radio>
                        <el-radio :label=0>不调用</el-radio>
                    </el-radio-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler1">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :append-to-body="true" title="删除设备对应卡号" :visible.sync="deleteShebeiFlg" width="600px"
            :close-on-click-modal="false">
            <el-form :model="dealWithForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/delete/shebei')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="deleteShebeiFlg = false">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>




        <el-dialog :append-to-body="true" title="修改用户可选套餐系列" :visible.sync="updateFlg" width="600px"
            @close="updateFlg = false" :close-on-click-modal="false">
            <el-form ref="updateData" :model="updateData" label-width="100px">
                <template v-if="batchImport">
                    <el-form-item label="导入Excel：" prop="uploadExcel">
                        <el-upload ref="upload" :action="uploadUrl('sim/update/batchGroup')" :headers="setHeader()"
                            :limit="1" :auto-upload="false" :data="updateData" :on-change="handleChange"
                            :on-success="handleSuccess">
                            <el-button slot="trigger" plain>导入Excel</el-button>
                            <el-button style="margin-left: 10px;" plain
                                @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                        </el-upload>
                    </el-form-item>
                </template>
                <el-form-item label="用户可选：" rop="groupBatchList">
                    <el-select v-model="updateData.groupBatchList" multiple filterable placeholder="（选填）用户是否可以自定义选择套餐系列">
                        <el-option v-for="item in pkgGroup" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateFlg = false">取 消</el-button>
                <el-button type="primary" @click="sureUpdate">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>

<script>
import { oneCardImport, getImportRecordList, getImportFailRecordList, oneCardImport1, oneCardImport12 } from '@/api/sim.js'
import { getSimTypeOption } from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data() {
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if (len > 0) {
                var extName = files[0].name.split('.')[1].toLowerCase();
                if (extName != 'xls' && extName != 'xlsx') {
                    return callback(new Error('请选择要导入的Excel文件'));
                } else {
                    callback();
                }
            } else {
                return callback(new Error('请选择要导入的Excel文件'))
            }
        }
        return {
            dealWithForm: {
                curSimCato: '',
                onQie: '',
            },
            deleteShebeiFlg: false,

            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            importCardForm: {
                iccid: '',
                iccidStart: '',
                iccidEnd: '',
                intoNoEnd: '',
                intoNo: '',
                agentId: '',
                supplierCode: '',
                basePkgGroup: '',
                cardType: '0',
                isReward: '0',
                virtualNo: ''
            },
            importCardVisible: false,
            batchImport: true,
            copyImport: false,
            batchSimsImport: false,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            currentId_fail: '',
            pkgGroup: [],
            agentListOption: [],
            branchSupplierOption: [],
            simTypeOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{ required: true, validator: checkImportFile }],
                supplierCode: [{ required: true, message: '请选择供应商', trigger: 'change' }],
                basePkgGroup: [{ required: true, message: '请选择套餐组', trigger: 'change' }],
            },


            importVisible: false,
            importVisible1: false,

            confirmExportDialogVisible: false,


            updateFlg: false,
            updateData: {
                groupBatchList: [],
                groupBatch: '',
            }

        }
    },
    methods: {
        updateBatchGroup() {
            common.getPkgGroupListCom(this, 'pkgGroup');
            this.updateFlg = true;
        },
        sureUpdate() {
            this.updateData.groupBatch = this.updateData.groupBatchList.join("-");
            this.$refs.updateData.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            });

        },


        exportApplyHandler() {
            var data = JSON.parse(JSON.stringify(this.importCardForm));
            this.exportExcel("/mould/download/allShebei", data);
            this.confirmExportDialogVisible = false;
        },



        handleSuccessSn(res) {
            if (res.code == 200) {
                this.importVisible = false;
                this.importVisible1 = false;
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        showImportApply() {
            this.importVisible = true;
        },
        showImportApply1() {
            this.importVisible1 = true;
        },
        importApplyHandler() {
            this.$refs.upload.submit();
        },
        importApplyHandler1() {
            this.$refs.dealWithForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });

        },
        importCancel() {
            this.importVisible = false;
            this.importVisible1 = false;
        },






        cancel() {
            this.batchSimsImport = false;
            this.importCardVisible = false;
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList) {
            if (fileList.length > 0) {
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', {});
            getImportRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportFailRecordListHandle(id, $event) {
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                recordId: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getImportFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
            this.batchImport = true;
        },
        showOneCardImport() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "单卡导入";
            this.batchImport = false;
        },
        showOneCardImport1() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "号段导入";
            this.batchSimsImport = true;
            this.batchImport = false;
        },
        showOneCardImport12() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "复制导入";
            this.copyImport = true;
            this.batchSimsImport = false;
            this.batchImport = false;
        },
        getOptionsOfSelect() {
            common.getAgentListOptionCom(this, 'agentListOption');
            common.getPkgGroupListCom(this, 'pkgGroup');
            common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
            getSimTypeOption().then(res => {
                if (res.data.code == 200) {
                    this.simTypeOption = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureImportCardHandle() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    if (this.batchImport) {
                        this.$refs.upload.submit();   //号段批量导入
                    } else if (this.batchSimsImport) {
                        var data = this.importCardForm;
                        oneCardImport1(data).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success('导入完成！');
                                this.getImportRecordListHandle();
                                this.importCardVisible = false;
                                this.batchSimsImport = false;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    } else if (this.copyImport) {
                        var data = this.importCardForm;
                        oneCardImport12(data).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success('导入完成！');
                                this.getImportRecordListHandle();
                                this.importCardVisible = false;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }
                    else {
                        var data = this.importCardForm;
                        oneCardImport(data).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success('导入完成！');
                                this.getImportRecordListHandle();
                                this.importCardVisible = false;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }
                }
            })
        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.updateFlg = false;
                this.importCardVisible = false;
                this.getImportRecordListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val) {
            if (this.importFailVisible) {
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val) {
            if (this.importFailVisible) {
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }
    },
    created() {
        this.getImportRecordListHandle();
    }
}
</script>

<style lang="less" scoped></style>
